import { numberFormat } from "highcharts";

export const CREDITS = {
    enabled: true,
    text: "Source: Nucleus",
    href: ""
};

export const STANDARD_CHART_STYLE = {
    fontSize: "13px",
    fontWeight: "normal",
    fontFamily: "vag-rounded-light",
    color: "#70655d"
};

export const BOLD_CHART_STYLE = {
    fontWeight: "bold",
    fontFamily: "vag-rounded-light",
    color: "#70655d",
    fontSize: "16px"
};

export function postLineBreak(pre) {
    return pre + "<br />";
}

export function formatTooltip(tooltipObject) {
    let tooltipString = `<div>${new Date(tooltipObject.x).toDateString()}<br /></div>`;

    if (!tooltipObject.point) {
        tooltipObject.points.forEach(entry => {
            if (entry?.series?.name !== "Range") {
                const formattedValue = numberFormat(entry.y, 2, ".", ",");
                const seriesName = entry.series.name;

                const circle = `<span style='color: ${entry.series.color};'>\u25CF </span>`;
                const value = `<span style='font-weight: bold'>${seriesName}</span>:\u00A3${formattedValue}`;
                tooltipString += `${circle + value}<br />`;
            }
        });
    } else {
        tooltipString += tooltipObject.point.text;
    }
    return `<div style='font-size: 10px'>${tooltipString}</div>`;
}

export function createSeries(series, name, yAxis, lineWidth, color, data) {
    series.push({ name, color, data, yAxis, lineWidth, id: name });
}

export function createZIndexedSeries(
    series,
    name,
    yAxis,
    lineWidth,
    color,
    data,
    type,
    linkedTo,
    zIndex
) {
    series.push({ name, yAxis, lineWidth, color, data, type, linkedTo, zIndex, id: name });
}

export function asCoordinates(x, y) {
    return { x, y };
}

export function asCoordinateArray(dataset) {
    return dataset.map(element =>
        asCoordinates(Date.parse(element.formattedEffectiveDate), element.amount)
    );
}

export function accountWithType(account, accounts) {
    if (account === "Combined") {
        return "Portfolio";
    } else {
        return accounts[account] === undefined
            ? account
            : account.concat(" ", accounts[account].wrapperType);
    }
}

export function formatChartMoney(input, accuracy = 2) {
    const output = input || 0;
    return output >= 0
        ? "\u00A3" + numberFormat(output, accuracy, ".", ",")
        : "-\u00A3" + numberFormat(output * -1, accuracy, ".", ",");
}

export function grossOrNet(netOfFeesText) {
    return netOfFeesText ? "(net)" : "(gross)";
}

export function asTuple(listA, listB) {
    const returnList = [];
    let listBcount = 0;

    for (let i = 0; i < listA.length; i++) {
        if (listA[i].formattedEffectiveDate === listB[listBcount].formattedEffectiveDate) {
            returnList.push([
                Date.parse(listA[i].formattedEffectiveDate),
                listA[i].amount,
                listB[listBcount].amount
            ]);
            listBcount++;
        }
    }

    return returnList;
}

export function accountWithClientDetails(account, accounts) {
    if (account === "Combined") {
        return "Portfolio";
    } else {
        const accountDetails = accounts[account];
        return accountDetails
            ? `${accountDetails.clientName} - ${accountDetails.clntId} - ${account} ${accountDetails.accountType}`
            : account;
    }
}

export const TRANSACTION_TYPE_COLOURS = {
    "Gain (gross)": "#ff6600",
    "Loss (gross)": "#ff6600",
    "Gain (net)": "#ff6600",
    "Loss (net)": "#ff6600",
    "Gain / loss": "#ff6600",
    Adjustments: "#009ba6",
    "Adviser charges": "#ffce4f",
    "Cash transfer in": "#e24786",
    "Cash transfer out": "#003568",
    "Employer payments": "#85a2c1",
    "Income distributions": "#70655d",
    "Inter account transfer in": "#563e5b",
    "Inter account transfer out": "#a8b9b9",
    "Interest distributions": "#006bb1",
    "Investment management fees": "#00a0e0",
    "Lump sum payment": "#637329",
    "Lump sum withdrawal": "#b35d4b",
    "Natural income": "#42528d",
    "Pension tax relief": "#00687f",
    "Platform charges": "#81842a",
    Rebates: "#f39a4a",
    "Regular payments": "#bcda2b",
    "Regular withdrawal": "#f5ae86",
    "Reregistration in": "#a580c2",
    "Reregistration out": "#8abce5"
};
